import { CCol, CContainer, CRow } from "@coreui/react";

const Error401 = () => {
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center text-dark">
          <CCol md={6}>
            <span className="clearfix">
              <h1 className="float-start display-3 me-4">401</h1>
              <h4 className="pt-3">No está autorizado!</h4>
              <p className="text-medium-emphasis float-start">
                Usted no está autorizado para ver esta página.
              </p>
            </span>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Error401;
